export default class memberInfoModel {
    constructor(memberInfo) {
        if (memberInfo.addresses == null) {
            memberInfo.addresses = [];
        }
        this.addresses = structuredClone(memberInfo.addresses);
        this.birthday = memberInfo.birthday;
        this.email = memberInfo.email;
        this.gender = memberInfo.gender;
        this.invoice_carrier = memberInfo.invoice_carrier;
        this.is_line_member = memberInfo.is_line_member;
        this.mobile_phone = memberInfo.mobile_phone;
        this.name = memberInfo.name;
        this.npo_ban = memberInfo.npo_ban;
        this.phone = memberInfo.phone;
        this.vat_number = memberInfo.vat_number;
        this.vip_level = memberInfo.vip_level;
        this.store_comment = memberInfo.store_comment;
        this.store_member_uuid = memberInfo.store_member_uuid;
        this.total_points = memberInfo.total_points;
    }
}